import { createContext, useContext, useCallback, useMemo } from 'react';
import { WorkpadConfig, safeWorkpadConfig } from '@eduwrite/shared';
import { useWorkpadStore } from '../store/useWorkpadStore';

interface ActivityWorkpadContextValue {
    config: WorkpadConfig;
    isOpen: boolean;
    openManually: () => void;
    requestScaffoldOnIncorrect: () => boolean;
}

const ActivityWorkpadContext = createContext<ActivityWorkpadContextValue>({
    config: { enabled: false, mode: 'none' },
    isOpen: false,
    openManually: () => {},
    requestScaffoldOnIncorrect: () => false,
});

export const ActivityWorkpadProvider = ActivityWorkpadContext.Provider;

export function useActivityWorkpad(): ActivityWorkpadContextValue {
    return useContext(ActivityWorkpadContext);
}

export function createActivityWorkpadValue(
    rawConfig: unknown,
    workpadEnabledFlag: boolean,
): ActivityWorkpadContextValue {
    const config = safeWorkpadConfig(rawConfig);
    const { isOpen, open } = useWorkpadStore.getState();

    const openManually = useCallback(() => {
        if (config.enabled && config.mode !== 'none') {
            open(config);
        }
    }, [config, open]);

    const requestScaffoldOnIncorrect = useCallback(() => {
        if (workpadEnabledFlag && config.enabled && config.mode === 'guided_steps') {
            open(config);
            return true;
        }
        return false;
    }, [workpadEnabledFlag, config, open]);

    return useMemo(
        () => ({
            config,
            isOpen,
            openManually,
            requestScaffoldOnIncorrect,
        }),
        [config, isOpen, openManually, requestScaffoldOnIncorrect],
    );
}
